<!-- Header -->
<h3 mat-dialog-title translate>
    Select Recipients
</h3>

<!-- Body -->
<mat-dialog-content>
    <div>
        {{selectedStudent.FirstName}} {{selectedStudent.LastName}} - <span translate>Not Enrolled in This School Year</span>
    </div>
    <div translate>
        Select a different year using the Year button in the top bar.
    </div>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky">
    <div class="flex-footer-left">
    </div>
    <div class="flex-footer-right">
        <tyl-button image="save.png" label="OK" (clickEvent)="ok()"></tyl-button>
    </div>
</mat-dialog-actions>